import React, { useState } from "react";
import { Menu, X } from "lucide-react";
import { useLanguage } from "../../context/LanguageProvider";
import LanguageSwitcher from "./LanguageSwitcher";

const Navbar: React.FC = () => {
  const { t } = useLanguage();
  const [isOpen, setIsOpen] = useState(false);

  const navItems = [
    { key: "nav_features", href: "#features" },
    // { key: "nav_pricing", href: "#pricing" },
    { key: "nav_about", href: "#about" },
    { key: "nav_contact", href: "#contact" },
  ];

  return (
    <nav className="bg-primary text-white sticky top-0 z-50 shadow-md">
      {" "}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-16">
          <div className="flex items-center">
            <div className="flex-shrink-0 flex items-center">
              {" "}
              <svg
                width="40"
                height="40"
                viewBox="0 0 100 100"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <title>FUKKONI Super App Icon</title>
                <desc>
                  Icon representing a central platform managing multiple
                  business types for FUKKONI.
                </desc>

                <defs>
                  <linearGradient
                    id="greenGradient"
                    x1="0%"
                    y1="0%"
                    x2="100%"
                    y2="100%"
                  >
                    <stop offset="0%" stop-color="#10B981" />{" "}
                    <stop offset="100%" stop-color="#34D399" />{" "}
                  </linearGradient>
                </defs>

                <rect
                  width="100"
                  height="100"
                  rx="20"
                  fill="url(#greenGradient)"
                />
                <circle cx="50" cy="50" r="15" fill="#ffffff" />
                <circle cx="30" cy="25" r="8" fill="#ffffff" />
                <circle cx="70" cy="25" r="8" fill="#ffffff" />
                <circle cx="20" cy="50" r="8" fill="#ffffff" />
                <circle cx="80" cy="50" r="8" fill="#ffffff" />
                <circle cx="30" cy="75" r="8" fill="#ffffff" />
                <circle cx="70" cy="75" r="8" fill="#ffffff" />
                <line
                  x1="50"
                  y1="50"
                  x2="30"
                  y2="25"
                  stroke="#ffffff"
                  stroke-width="4"
                  stroke-linecap="round"
                />
                <line
                  x1="50"
                  y1="50"
                  x2="70"
                  y2="25"
                  stroke="#ffffff"
                  stroke-width="4"
                  stroke-linecap="round"
                />
                <line
                  x1="50"
                  y1="50"
                  x2="20"
                  y2="50"
                  stroke="#ffffff"
                  stroke-width="4"
                  stroke-linecap="round"
                />
                <line
                  x1="50"
                  y1="50"
                  x2="80"
                  y2="50"
                  stroke="#ffffff"
                  stroke-width="4"
                  stroke-linecap="round"
                />
                <line
                  x1="50"
                  y1="50"
                  x2="30"
                  y2="75"
                  stroke="#ffffff"
                  stroke-width="4"
                  stroke-linecap="round"
                />
                <line
                  x1="50"
                  y1="50"
                  x2="70"
                  y2="75"
                  stroke="#ffffff"
                  stroke-width="4"
                  stroke-linecap="round"
                />
              </svg>
              <span className="ml-2 text-xl font-bold">{t("nav_brand")}</span>
            </div>
          </div>

          <div className="hidden md:block">
            <div className="ml-10 flex items-center space-x-4">
              {" "}
              {navItems.map((item) => (
                <a
                  key={item.key}
                  href={item.href}
                  className="px-3 py-2 rounded-md text-sm font-medium hover:bg-secondary/30 transition-colors duration-300" // Adjusted hover color slightly
                >
                  {t(item.key)}
                </a>
              ))}
              <div className="ml-4">
                {" "}
                <LanguageSwitcher />
              </div>
              <a
                href="https://app.fukkoni.com/register"
                className="bg-white text-primary px-4 py-2 rounded-md text-sm font-medium hover:bg-gray-100 transition-colors duration-300"
              >
                {t("hero_button_getStarted")}
              </a>
            </div>
          </div>

          <div className="md:hidden flex items-center">
            {" "}
            <div className="mr-2">
              {" "}
              <LanguageSwitcher />
            </div>
            <button
              onClick={() => setIsOpen(!isOpen)}
              className="inline-flex items-center justify-center p-2 rounded-md hover:bg-secondary/30 focus:outline-none transition-colors duration-300" // Adjusted hover color
              aria-label={
                isOpen ? t("nav_close_menu_aria") : t("nav_open_menu_aria")
              }
            >
              {isOpen ? (
                <X className="h-6 w-6" aria-hidden="true" />
              ) : (
                <Menu className="h-6 w-6" aria-hidden="true" />
              )}
            </button>
          </div>
        </div>
      </div>
      <div className={`md:hidden ${isOpen ? "block" : "hidden"}`}>
        <div className="px-2 pt-2 pb-3 space-y-1 sm:px-3">
          {navItems.map((item) => (
            <a
              key={item.key}
              href={item.href}
              onClick={() => setIsOpen(false)}
              className="block px-3 py-2 rounded-md text-base font-medium hover:bg-secondary/30 transition-colors duration-300" // Adjusted hover color
            >
              {t(item.key)}
            </a>
          ))}

          <a
            href="https://app.fukkoni.com/register"
            className="w-full mt-2 bg-white text-primary px-4 py-2 rounded-md text-sm font-medium hover:bg-gray-100 transition-colors duration-300 text-center"
          >
            {t("hero_button_getStarted")}
          </a>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
